"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./api/index"), exports);
tslib_1.__exportStar(require("./core/index"), exports);
tslib_1.__exportStar(require("./types/index"), exports);
tslib_1.__exportStar(require("./utils/index"), exports);
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./~/pdf-lib/cjs/index.js